import React from 'react';
import { mdiHorseVariant } from '@mdi/js';
import { SvgIcon } from '@mui/material';

const HorseIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d={mdiHorseVariant} />
    </SvgIcon>
  );
};

export default HorseIcon;

